import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from '@/locales/zh.json';
import en from '@/locales/en.json';

const STORAGE_KEY = 'app_lang';
const defaultLng = 'en';

export const supportedLngs = ['zh', 'en'] as const;
export type Locale = (typeof supportedLngs)[number];

function getStoredLang(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && supportedLngs.includes(stored as Locale)) return stored;
  } catch (_) {}
  return defaultLng;
}

i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    en: { translation: en },
  },
  lng: getStoredLang(),
  fallbackLng: defaultLng,
  interpolation: { escapeValue: false },
});

export function setAppLanguage(lng: Locale): void {
  i18n.changeLanguage(lng);
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (_) {}
}

export default i18n;
